import { TextColors } from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      position: 'absolute',
      bottom: 'calc(0px - 40px)',
      [mediaQuery(BreakPoints.Small)]: {
        bottom: 'calc(0px - 16px)',
      },
    },
    text: {
      width: 'max-content',
      color: TextColors.tint3,
      fontWeight: FontWeights.semibold,
    },
  },
  {
    name: 'templates-count',
  },
);
export default useStyles;
